import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import { useStateContext } from "../contexts/ContextProvider";
import Button from "./Button";
import ProgressBar from "./ProgressBar";
import { MdDeleteForever } from "react-icons/md";
import { apiCreateBill } from "../services/apiService";
import ImageUploader from "./ImageUploader";

const initialErrorState = {
  billType: "",
  serviceStart: "",
  serviceEnd: "",
  totalAmount: "",
  images: "",
  noRoomIds: "",
};

const AddBill = (props) => {
  const { currentProperty } = props;
  const { rooms, leases, setBills, setTransactions, handleModal } =
    useStateContext();
  const [error, setError] = useState(initialErrorState);
  const [imageUploadError, setImageUploadError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [tooManyFiles, setTooManyFiles] = useState(false);
  const [hasBillableLeases, setHasBillableLeases] = useState(true);
  const [roomNamesArr, setRoomNamesArr] = useState([]);

  const [page, setPage] = useState(1);
  const pages = 5;

  const currentLeases = leases.filter(
    (x) =>
      x.propertyId === currentProperty.id &&
      x.status === "active" &&
      x.splitsBills === true
  );

  const [bill, setBill] = useState({
    landlordId: currentProperty.landlordId,
    propertyId: currentProperty.id,
    tenantIds: [],
    billType: "--",
    otherType: "",
    totalAmount: "",
    splitAmount: "",
    serviceStart: "",
    serviceEnd: "",
    dueDate: "",
    images: [],
    leaseIds: [],
  });

  useEffect(() => {
    setHasBillableLeases(true);
    setBill((prevState) => ({ ...prevState, leaseIds: [] }));
    getLeaseIds();
  }, [bill.billType, bill.totalAmount]);

  const nextPage = async () => {
    if (hasErrors()) {
      return;
    } else {
      setPage(page + 1);
    }
  };

  const prevPage = () => {
    setPage(page - 1);
  };

  const getLeaseIds = () => {
    const billedLeases = currentLeases.filter((x) => x[bill.billType] === true);

    let tenantIdsArray = billedLeases.map((x) => {
      return x.tenantId;
    });

    let leaseIdsArray = billedLeases.map((x) => {
      return x.id;
    });

    if (bill.billType !== "--" && leaseIdsArray.length === 0) {
      setHasBillableLeases(false);
    } else {
      let splitAmount = Math.ceil(
        (Number(bill.totalAmount) * 100) / leaseIdsArray.length
      );

      getRoomNames();
      setBill((prevState) => ({
        ...prevState,
        tenantIds: tenantIdsArray,
        leaseIds: leaseIdsArray,
        splitAmount: `${splitAmount}`,
      }));
    }
  };

  const getRoomNames = () => {
    let namesArray = bill.leaseIds.map((x) => {
      return leases.find((y) => y.id === x).roomName;
    });
    setRoomNamesArr(namesArray);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const reg = new RegExp("^[0-9.]*$"); // numbers and decimals only
    let safeValue = value;

    if (name === "totalAmount") {
      if (reg.test(value)) {
        setBill((prevState) => ({ ...prevState, [name]: safeValue }));
      } else {
        return;
      }
    } else {
      setBill((prevState) => ({ ...prevState, [name]: safeValue }));
    }
  };

  const addBill = async () => {
    console.log(bill);
    bill.totalAmount = `${Math.ceil(bill.totalAmount * 100)}`;
    const response = await apiCreateBill(bill);
    console.log(response.data);
    //TODO: may need to add 'isLoading' functionality (due to slow response)
    if (response.hasError) {
      //TODO: add error message
      return;
    } else {
      setBills((prevState) => [...prevState, response.data.bill]);
      setTransactions((prevState) => [
        ...prevState,
        response.data.transactions,
      ]);
      handleModal("addBill");
    }
  };

  // const handleImages = (event) => {
  //   const newImagesObj = event.target.files;
  //   let safeArray = bill.images;
  //   let list = new DataTransfer();

  //   if (safeArray.length + newImagesObj.length > maxUploads) {
  //     setImageUploadError(true);
  //     setTooManyFiles(true);
  //     resetImageErrors();
  //     document.getElementById("images").value = "";
  //     return;
  //   }

  //   for (let i = 0; i < newImagesObj.length; i++) {
  //     //TODO: create env for max image size
  //     if (newImagesObj[i].size <= 2 * 1024 * 1024) {
  //       safeArray.push(newImagesObj[i].name); // remove .name for full image object
  //       let file = new File([newImagesObj[i].type], newImagesObj[i].name);
  //       list.items.add(file);
  //     } else {
  //       setErrorArray((prevState) => [...prevState, newImagesObj[i].name]);
  //       setImageUploadError(true);
  //       resetImageErrors();
  //       continue;
  //     }
  //   }

  //   // TODO: rename images => send to image server => send filenames to backend.
  //   document.getElementById("images").files = list.files;
  //   setBill((prevState) => ({ ...prevState, images: safeArray }));
  // };

  // const removeImage = (index) => {
  //   setBill((prevState) => ({
  //     ...prevState,
  //     images: bill.images.toSpliced(index, 1),
  //   }));
  //   const oldFileList = Array.from(document.getElementById("images").files);
  //   let list = new DataTransfer();
  //   for (let i = 0; i < oldFileList.length; i++) {
  //     if (i === index) {
  //       continue;
  //     } else {
  //       let file = new File([oldFileList[i].type], oldFileList[i].name);
  //       list.items.add(file);
  //     }
  //   }
  //   document.getElementById("images").files = list.files;
  // };

  const hasErrors = () => {
    const reg = new RegExp("^[0-9]*.[0-9]{2}$"); // float to two places
    if (page === 1 && bill.billType === "--") {
      activateError("billType");
      return true;
    } else if (page === 1 && bill.leaseIds.length === 0) {
      activateError("noRoomIds");
      return true;
    } else if (page === 2 && bill.serviceStart === "") {
      activateError("serviceStart");
      return true;
    } else if (page === 2 && bill.serviceEnd === "") {
      activateError("serviceEnd");
      return true;
    } else if (page === 2 && bill.dueDate === "") {
      activateError("dueDate");
      return true;
    } else if (page === 3 && !reg.test(bill.totalAmount)) {
      activateError("totalAmount");
      return true;
    } else if (page === 4 && bill.images.length === 0) {
      activateError("images");
      return true;
    } else {
      return false;
    }
  };

  const activateError = (item) => {
    setError((prevState) => ({
      ...prevState,
      [item]: "animate-shake text-red-600 border-red-600",
    }));
    setTimeout(
      () => {
        setError((prevState) => ({
          ...prevState,
          [item]: "",
        }));
      },
      item === "images" ? 1000 : 500 // longer timeout for images error
    );
    clearTimeout();
  };

  // const resetImageErrors = () => {
  //   setTimeout(() => {
  //     setImageUploadError(false);
  //     setTooManyFiles(false);
  //     setErrorArray([]);
  //   }, 5000);
  //   clearTimeout();
  // };

  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      <ProgressBar pages={pages} currentPage={page} />
      <form
        className="grid justify-items-center"
        onSubmit={(e) => {
          e.preventDefault();
          page === pages ? AddBill() : nextPage();
        }}
      >
        {page === 1 && (
          <>
            <div
              className={`text-lg text-center mt-10 mb-5 px-10 ${error.billType}`}
            >
              What type of bill is this? <span className="text-red-500">*</span>
            </div>
            <label className="grid">
              <select
                id="bill-type"
                name="billType"
                value={bill.billType}
                autoFocus={true}
                className={`w-40 border-gray-300 border-1 rounded-md ${error.billType}`}
                onChange={handleChange}
                onChangeCapture={() => {}}
              >
                <option disabled>--</option>
                <option value="paysGas">Gas</option>
                <option value="paysElectric">Electric</option>
                <option value="paysWater">Water</option>
                <option value="paysSewer">Sewer</option>
                <option value="paysCable">Cable</option>
                <option value="paysPhone">Phone</option>
                <option value="paysInternet">Internet</option>
                <option value="paysHoa">Condo/HOA</option>
              </select>
            </label>
            {/* {bill.billType === "other" && (
              <label className={`grid mt-5 ${error.otherType}`}>
                <div>
                  Description: <span className="text-red-500">*</span>
                </div>
                <input
                  id="other-type"
                  name="otherType"
                  type="text"
                  maxLength={30}
                  placeholder="Description"
                  value={bill.otherType}
                  autoFocus={true}
                  className={`w-40 border-gray-300 border-1 rounded-md px-1 ${error.otherType}`}
                  onChange={handleChange}
                />
              </label>
            )} */}
            {!hasBillableLeases && (
              <div className="mt-5 p-10">
                <div
                  className={`text-center border-gray-300 border-2 rounded-2xl p-10 ${error.noRoomIds}`}
                >
                  None of your active leases allow splititng this type of bill.
                </div>
              </div>
            )}
          </>
        )}
        {page === 2 && (
          <>
            <div className="flex justify-center text-lg mt-10">
              What is the service period for this bill?
            </div>
            <label className={`flex mt-5 ${error.serviceStart}`}>
              Start Date: <span className="text-red-500 mr-1">*</span>
              <input
                id="lease-start"
                name="serviceStart"
                type="date"
                min={DateTime.now().minus({ months: 6 }).toFormat("yyyy-MM-dd")}
                value={bill.serviceStart}
                autoFocus={true}
                className={`border-gray-300 border-1 rounded-md pl-1${error.serviceStart}`}
                onChange={handleChange}
              />
            </label>
            <label className={`flex mt-5 ${error.serviceEnd}`}>
              End Date: <span className="text-red-500 mr-1">*</span>
              <input
                id="service-end"
                name="serviceEnd"
                type="date"
                min={bill.serviceStart}
                value={bill.serviceEnd}
                className={`border-gray-300 border-1 rounded-md pl-1${error.serviceEnd}`}
                onChange={handleChange}
              />
            </label>
            <label className={`flex mt-5 ${error.serviceEnd}`}>
              Due Date: <span className="text-red-500 mr-1">*</span>
              <input
                id="due-date"
                name="dueDate"
                type="date"
                min={bill.serviceEnd}
                value={bill.dueDate}
                className={`border-gray-300 border-1 rounded-md pl-1${error.dueDate}`}
                onChange={handleChange}
              />
            </label>
          </>
        )}
        {page === 3 && (
          <>
            <div
              className={`text-lg text-justified mt-10 mb-1 px-10 ${error.totalAmount}`}
            >
              What are the total NEW charges?
              <span className="text-red-500">*</span>
            </div>
            <label className="grid">
              <div className="flex relative">
                <div className="absolute left-2">$</div>
                <input
                  id="total-amount"
                  name="totalAmount"
                  type="tel"
                  maxLength={7}
                  placeholder="150.00"
                  autoFocus={true}
                  value={bill.totalAmount}
                  className={`w-40 text-right border-gray-300 border-1 rounded-md pr-1 ${error.totalAmount}`}
                  onChange={handleChange}
                />
              </div>
            </label>
          </>
        )}
        {page === 4 && (
          <>
            <ImageUploader
              stateObject={bill}
              setStateObject={setBill}
              name="bills"
            />
            {error.images && (
              <div className={`mt-5 ${error.images}`}>
                You must upload a copy of the bill.
              </div>
            )}
          </>

          // <div className="grid justify-items-center mt-10">
          //   <div className={`flex justify-center text-lg ${error.images}`}>
          //     Please upload a copy of the bill.
          //   </div>
          //   <label className="grid mt-5">
          //     <input
          //       id="images"
          //       name="images"
          //       type="file"
          //       multiple
          //       accept="image/*, application/pdf"
          //       className={`w-72 border-gray-300 border-1 rounded-md mt-5 ${error.images}`}
          //       onChange={handleImages}
          //     />
          //   </label>
          //   <div className="mt-5">
          //     {/* {bill.images.length > 0 ? (
          //       <div>{bill.images.length} Files:</div>
          //     ) : (
          //       ""
          //     )} */}
          //     {bill.images.map((item, index) => {
          //       return (
          //         <div key={index} className="flex">
          //           <div className="w-48 text-gray-500 truncate text-ellipsis mr-0.5">
          //             {item.name}
          //           </div>
          //           <MdDeleteForever
          //             className="text-xl bg-gray-300 hover:bg-red-500"
          //             onClick={() => {
          //               removeImage(index);
          //             }}
          //           />
          //         </div>
          //       );
          //     })}
          //   </div>

          //   {imageUploadError && errorArray.length > 0 && (
          //     <div className="text-center text-red-500 mt-2 px-20">
          //       {errorArray.length}
          //       {errorArray.length > 1 ? " Files were" : " File was"} too large.
          //     </div>
          //   )}
          //   {imageUploadError && tooManyFiles && (
          //     <div className="text-center text-red-500 mt-2 px-20">
          //       Too Many Files. The max is {maxUploads} images.
          //     </div>
          //   )}
          // </div>
        )}
        {page === pages && (
          <div className="grid justify-items-center mt-5">
            <div className="flex justify-center">Summary:</div>
            <div className="p-5">
              <div className="border-gray-300 border-2 rounded-2xl p-10 capitalize">
                <div className="flex justify-center text-xl">
                  {bill.billType.split("pays")} Bill
                </div>
                <div
                  className="flex justify-center text-sm text-blue-500 hover:text-blue-700"
                  onClick={() => setPage(2)}
                >
                  (
                  {DateTime.fromFormat(
                    bill.serviceStart,
                    "yyyy-MM-dd"
                  ).toFormat("MM/d/yyyy")}{" "}
                  -{" "}
                  {DateTime.fromFormat(bill.serviceEnd, "yyyy-MM-dd").toFormat(
                    "MM/dd/yyyy"
                  )}
                  )
                </div>
                <div className="grid grid-cols-2 gap-x-10 mt-5">
                  <div>Total:</div>
                  <div
                    className="place-self-end text-blue-500 hover:text-blue-700"
                    onClick={() => setPage(3)}
                  >
                    ${bill.totalAmount}
                  </div>
                  <div>Per Room:</div>
                  <div className="place-self-end">
                    ${(bill.splitAmount / 100).toFixed(2)}
                  </div>
                  <div>Due Date:</div>
                  <div className="place-self-end">
                    {DateTime.fromFormat(bill.dueDate, "yyyy-MM-dd").toFormat(
                      "MM/dd/yyyy"
                    )}
                  </div>
                </div>
                <div>
                  <div className="flex justify-center mt-5">Split Between:</div>
                  <div
                    className={` ${
                      roomNamesArr.length === 1
                        ? "flex justify-center"
                        : roomNamesArr.length > 3
                        ? "grid grid-cols-3 justify-items-center"
                        : "grid grid-cols-2 justify-items-center"
                    }`}
                  >
                    {roomNamesArr.map((item, index) => {
                      return <div key={index}>{item}</div>;
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </form>
      <div className="flex justify-center w-full fixed top-[525px]">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={page === 1 ? "Close" : "Back"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={page === 1 ? () => handleModal("addBill") : prevPage}
        />
        <Button
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={page === pages ? "Submit" : "Next"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={
            page === pages
              ? addBill
              : () => {
                  nextPage();
                }
          }
        />
      </div>
    </div>
  );
};

export default AddBill;
